import { useLocation } from 'react-router-dom'

interface HeaderProps {
  title?: string
  subtitle?: string
  actions?: React.ReactNode
}

export default function Header({ title, subtitle, actions }: HeaderProps) {
  const location = useLocation()

  const getPageInfo = () => {
    switch (location.pathname) {
      case '/':
      case '/dashboard':
        return { title: 'Dashboard', subtitle: 'Monitor your business performance', icon: '📊' }
      case '/orders':
        return { title: 'Orders', subtitle: 'Manage and track your orders', icon: '📦' }
      case '/sales':
        return { title: 'Sales Analytics', subtitle: 'View your sales performance and metrics', icon: '💰' }
      case '/logs':
        return { title: 'Logs & Monitoring', subtitle: 'Monitor bot activities and system logs', icon: '📋' }
      case '/settings':
        return { title: 'Settings', subtitle: 'Configure your system and preferences', icon: '⚙️' }
      default:
        return { title: 'Obayito Admin', subtitle: 'Admin Dashboard', icon: '🚀' }
    }
  }

  const pageInfo = getPageInfo()
  const displayTitle = title || pageInfo.title
  const displaySubtitle = subtitle || pageInfo.subtitle

  return (
    <div
      style={{
        background: 'white',
        borderBottom: '1px solid #e2e8f0',
        padding: '1.5rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      }}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.25rem' }}>
          <span style={{ fontSize: '1.5rem' }}>{pageInfo.icon}</span>
          <h1
            style={{
              margin: 0,
              fontSize: '1.75rem',
              fontWeight: '700',
              color: '#1e293b',
            }}
          >
            {displayTitle}
          </h1>
        </div>
        {displaySubtitle && (
          <p
            style={{
              margin: 0,
              fontSize: '0.95rem',
              color: '#64748b',
            }}
          >
            {displaySubtitle}
          </p>
        )}
      </div>

      {actions && (
        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          {actions}
        </div>
      )}
    </div>
  )
}